var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1802_20214)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.5C3.85625 0.5 0.5 3.85625 0.5 8C0.5 11.3188 2.64687 14.1219 5.62812 15.1156C6.00312 15.1813 6.14375 14.9563 6.14375 14.7594C6.14375 14.5813 6.13438 13.9906 6.13438 13.3625C4.25 13.7094 3.7625 12.9031 3.6125 12.4813C3.52813 12.2656 3.1625 11.6 2.84375 11.4219C2.58125 11.2812 2.20625 10.9344 2.83437 10.925C3.425 10.9156 3.84687 11.4688 3.9875 11.6938C4.6625 12.8281 5.74063 12.5094 6.17188 12.3125C6.2375 11.825 6.43437 11.4969 6.65 11.3094C4.98125 11.1219 3.2375 10.475 3.2375 7.60625C3.2375 6.79063 3.52813 6.11563 4.00625 5.59063C3.93125 5.40313 3.66875 4.63438 4.08125 3.60313C4.08125 3.60313 4.70937 3.40625 6.14375 4.37188C6.74375 4.20313 7.38125 4.11875 8.01875 4.11875C8.65625 4.11875 9.29375 4.20313 9.89375 4.37188C11.3281 3.39688 11.9563 3.60313 11.9563 3.60313C12.3688 4.63438 12.1062 5.40313 12.0312 5.59063C12.5094 6.11563 12.8 6.78125 12.8 7.60625C12.8 10.4844 11.0469 11.1219 9.37813 11.3094C9.65 11.5438 9.88438 11.9938 9.88438 12.6969C9.88438 13.7 9.875 14.5063 9.875 14.7594C9.875 14.9563 10.0156 15.1906 10.3906 15.1156C13.3531 14.1219 15.5 11.3094 15.5 8C15.5 3.85625 12.1438 0.5 8 0.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1802_20214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/github-logo.5d7d554fb1ccef6a1a555c62cb9cb925.svg";
export { ForwardRef as ReactComponent };